export default {
      id: "icon--wear-wooly-gloves-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wear-wooly-gloves-usage",
      toString: function () {
        return this.url;
      }
    }